<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="-1.5 -3 20 20"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M15.333 8.667V12c0 1.105-.895 2-2 2H2.667c-1.105 0-2-.895-2-2V8.667c0-.094.02-.186.057-.271L3.037 3.19C3.358 2.466 4.075 2 4.867 2h6.266c.792 0 1.51.466 1.83 1.19l2.313 5.206.016.039c.005.013.01.026.013.04l.022.099c.004.03.006.062.006.093zM2 12c0 .368.298.667.667.667h10.666c.369 0 .667-.299.667-.667V9.333h-2.977l-1.135 1.703c-.124.186-.332.297-.555.297H6.667c-.223 0-.431-.111-.555-.297L4.977 9.333H2V12zm9.133-8.667H4.866c-.264 0-.503.156-.61.397L2.36 8h2.974c.191 0 .372.082.497.222l.058.075L7.023 10h1.954l1.135-1.703c.124-.186.332-.297.555-.297h2.974l-1.897-4.27c-.107-.241-.346-.397-.61-.397z"
      />
      <circle v-if="msgActive" cx="16" cy="0" r="2" :fill="msgColor" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-inbox",
  components: {},
})
export class IconInbox extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
  @Prop() public msgColor!: string;
  @Prop() public msgActive!: boolean;

  constructor() {
    super();
  }
}
export default IconInbox;
</script>
